// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__3A56k","active":"LanguageItems_active__3H6R8"};